// extracted by mini-css-extract-plugin
export default {"alink":"alink__pSY2t","alink-grounp":"alink-grounp__cq7vZ","alink-grounp-center":"alink-grounp-center__20KEq","alink-grounp-left":"alink-grounp-left__wrNdg","gold":"gold__5fA33"};